import React from "react";
import { TableRow, TableCell, IconButton } from '@mui/material';
import { ArrowForwardIos as ArrowForwardIcon } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import CommentsMenu from '../components/CommentsMenu';
import { RoleMapping } from "../constants/roles";
import ImageGalleryDropdown from '../components/ImageGalleryDropdown';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';

function UserRow({ user, users }) {
    const images = user.bucket?.images || [];
    return (
        <TableRow>
            <TableCell>
                <IconButton
                    component={Link}
                    to={`/users/${user.id}`}
                    state={{ records: users }}
                    aria-label="view-details"
                >
                    <ArrowForwardIcon sx={{ fontSize: 'small' }} />
                </IconButton>
            </TableCell>
            <TableCell>{user.name}</TableCell>
            <TableCell>{user.email}</TableCell>
            <TableCell>{user.phone}</TableCell>
            <TableCell>{RoleMapping[user.role]}</TableCell>
            <TableCell>
                <CommentsMenu comments={user.comments} />
            </TableCell>
            <TableCell>
                {images.length > 1 ? (
                    <ImageGalleryDropdown
                        images={images}
                        onUploadSuccess={null}
                        onDelete={null}
                        userId={user.id}
                        readOnly={true}
                    />
                ) : images.length === 1 ? (
                    <a href={images[0].imageUrl} target="_blank" rel="noopener noreferrer">
                        <IconButton aria-label="view image">
                            <PhotoLibraryIcon sx={{ fontSize: '18px', color: 'primary.main' }} />
                        </IconButton>
                    </a>
                ) : null}
            </TableCell>
        </TableRow>
    );
}

export default UserRow;